<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }">
    <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="6" nzLg="8" nzXl="10">
        <h1 class="page-title">Shipped Orders
            <span nz-icon nzType="reload" nzTheme="outline" class="reloadDateIcon notPrintable cursor"
                (click)="getShippedData()" nz-tooltip nzTooltipTitle="Reload Data"
                nzTooltipPlacement="bottomLeft"></span>
        </h1>
    </div>
    <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="14" class="btnsearch">
        <div class="header-right-box change_ship_date">

            <div class="date-filter-div">
                <input type="text" class="form-control date-picker input mr-1" [readonly]="true" ngxDaterangepickerMd
                    [(ngModel)]="selected" (ngModelChange)="onDateChange($event)" placeholder="Filter By Date"
                    [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [ranges]="ranges" [opens]="'left'"
                    [showClearButton]="true">
            </div>
        </div>
    </div>
</div>


<div class="table-height">
    <nz-table class="main-table-header statusTable" #sortTable [nzData]="lst_Status" nzTableLayout="fixed"
        [nzFrontPagination]="false" [nzShowPagination]="false"
        [ngClass]="{'table-loading' : lst_Status.length > 0 || isStatusLoaded}">

        <thead>
            <tr class="tableheader">
                <!-- <th nzWidth="50px" [nzAlign]="'left'">SL#</th> -->
                <th nzWidth="110px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('invoice')">QB
                    Invoice# </th>
                <th nzWidth="170px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('name')">QB Customer
                    Name </th>
                <th nzWidth="150px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('poNumber')">PO
                    Number </th>
                <th nzWidth="130px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('qbshipdate')">QB
                    Ship Date </th>
                <th nzWidth="153px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('qbpaymentstatus')">
                    QB Pmt Status</th>
                <th nzWidth="150px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('qbblstatus')">QB BL
                    Status </th>
                <th nzWidth="150px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('qbshipvia')">QB Ship
                    Via </th>
                <th nzWidth="180px" [nzAlign]="'left'">QB Delivery Phone</th>
                <th nzWidth="180px" [nzAlign]="'left'">QB Tracking</th>
                <th nzWidth="120px" [nzAlign]="'center'">Action</th>
            </tr>
        </thead>

        <tbody *ngIf="lst_Status.length > 0">
            <tr *ngFor="let data of lst_Status; let i = index">
                <!-- <td [nzAlign]="'left'">{{ i + 1 }}</td> -->

                <td [nzAlign]="'center'">
                    <span>
                        <a [href]="'https://app.qbo.intuit.com/app/invoice?txnId='+data.transactionID"
                            target="_blank">{{ data.invoiceNo }} </a>
                    </span>
                </td>

                <td [nzAlign]="'left'">{{ data.customerName }}</td>

                <td [nzAlign]="'left'">
                    <ng-container *ngIf="data.poNumber?.startsWith('WS-') || data.poNumber?.startsWith('CS-'); else plainText">
                        <a [href]="'https://partners.wayfair.com/d/outbound-orders/po/' + data.poNumber" target="_blank"
                            rel="noopener">
                            {{ data.poNumber }}
                        </a>
                    </ng-container>
                    <ng-template #plainText>
                        {{ data.poNumber }}
                    </ng-template>
                </td>

                <td [nzAlign]="'center'">{{ data.qB_ShipDate | date: 'MM/dd/yyyy' }}</td>
                <td [nzAlign]="'left'">{{ data.qB_PaymentStatus }}</td>
                <!-- <td [nzAlign]="'left'">{{ data.qB_BL_Status }}</td> -->
                <td [nzAlign]="'left'" [ngStyle]="{
                                                    'background-color': data.qB_BL_Status === 'Delivered' ? '#00cc00' : 
                                                                        data.qB_BL_Status === 'InTransit' ? '#ffff4d' : 'transparent'
                                                }">
                    {{ data.qB_BL_Status }}
                </td>

                <td [nzAlign]="'left'">{{ data.qB_ShipVia }}</td>
                <td [nzAlign]="'left'">{{ data.qB_DeliveryPh }}</td>
                <td [nzAlign]="'left'">
                    <span>
                        <a [href]="'https://badeloft.aftership.com/' + data.qB_TrackingNo" target="_blank"
                            rel="noopener noreferrer">{{ data.qB_TrackingNo }}</a>
                    </span>
                </td>
                <td [nzAlign]="'center'">
                    <span *ngIf="!isDelivered(data)" class="mr-1" nz-icon nzType="cloud-sync" nzTheme="outline" nz-tooltip
                        [nzTooltipTitle]="data.qB_TrackingNo ? 'Sync from AfterShip' : 'No tracking number'"
                        [ngClass]="{'disable-icon' : !data.qB_TrackingNo}"
                        (click)="$event.stopPropagation(); showAfterShipSync(data)"></span>
                    <a (click)="$event.stopPropagation()" nz-button nzType="default" nzOkText="Yes" nzCancelText="No"
                        nz-popconfirm nzPopconfirmTitle="Are you sure you want to mark this item as returned?"
                        (nzOnConfirm)="UpdateShippedReturnStatus(data)">Return</a>
                </td>
            </tr>
        </tbody>

    </nz-table>
</div>
<app-aftership-sync *ngIf="afterShipOrder" [order]="afterShipOrder"
    (hideModal)="hideAfterShipSync($event)"></app-aftership-sync>